export const messagesMarketingGenerics = {
    pt: {
        message:{
            access: "Acesso",
            actions: "Ações",
            at: "às",
            automation: "Automação",
            birthday: "Aniversário",
            content: "Conteúdo",
            creditHistory: "Histórico de créditos",
            currentDataBase: "Base atual",
            customSegmentedList: "Lista segmentada customizada",
            dataOrigin: "Origem dos dados",
            deleteMessage: "Deletar Mensagem",
            deleteMessageConfirmation: "Quer mesmo deletar esta mensagem? Esta ação é irreversível",
            downloadFileTemplate: "Baixar modelo de arquivo",
            dropZoneFile: "Ou selecione um arquivo do seu computador",
            dropZoneText: "Arraste e solte sua lista em um arquivo .CSV ou Excel (.xls ou .xlsx)",
            enablePeriodFilter: "Habilitar filtro de período",
            entryCriteria: "Critério de entrada",
            estimatedSendAmount: "Valor estimado de envio",
            executing: "Executando",
            externalBaseFile: "Arquivo de base externa",
            externalFileEmail: "Insira um arquivo com apenas uma coluna com os emails desejados",
            externalFileSms: "Insira um arquivo com apenas uma coluna com os números de DDD + telefone",
            genderAndAge: "Sexo e idade",
            importExternalBase: "Importar base externa de clientes",
            importNewFile: "Importar novo arquivo",
            inXDays: "Em X dias",
            leads: "cadastros",
            linkedWithFlow: "Em uso",
            message: "Mensagem",
            messageHint: "Digite a mensagem que deseja enviar aos destinatários.",
            nextStep: "Próximo passo",
            numberOfDays: "Quantidade de dias",
            numberSent: "Envios",
            partiallySent: "Parcialmente Enviado",
            pastDays: "Dias passados",
            period: "Período",
            periodType: "Tipo de período",
            plainText: "Texto simples",
            plainTextHint: "O WiFeed cria automaticamente uma versão em texto simples para enviar caso não seja possível entregar a versão completa",
            recipients: "Destinatários",
            register: "Registro",
            saveDraft: "Salvar Rascunho",
            saved: "Salvo",
            saving: "Salvando...",
            schedule: "Agendar envio",
            scheduleTime: "Hora envio",
            scheduled: "Agendado",
            send: "Envio",
            sendDate: "Data de envio",
            sendEntireDataBase: "Enviar para toda a base de cadastros",
            sendNow: "Enviar agora",
            sendSegmentedList: "Enviar para lista segmentada de cadastros",
            sendTest: "Enviar Teste",
            sending: "Enviando",
            sent: "Enviado",
            singleSend: "Envio único",
            template: "Modelo",
            testSubmission: "Envio de teste",
            testSubmissionHint: "Os envios de teste servem para verificar se as configurações foram aplicadas corretamente",
            title: "Título",
            tooltipFirstName: "Para colocar o nome do usuário que você está mandando a mensagem, é só colocar a variável abaixo na mensagem",
            valueNotFilled: "Este valor não está preenchido",
            verification: "Verificação",
            waitingToBeSent: "Aguardando Envio",
            warning: "Atenção",
            warningRecipientsList: "A lista de destinatários será atualizada no momento do envio.",
            error: "Erro ao Enviar",

        }
    },
    es: {
        message:{
            access: "Acceso",
            actions:"Acciones",
            at:"a",
            automation:"Automatización",
            birthday: "Cumpleaños",
            content:"Contenido",
            creditHistory:"Historia de créditos",
            currentDataBase:"Base actual",
            customSegmentedList: "Lista segmentada personalizada",
            dataOrigin:"Origen de datos",
            deleteMessage:"Borrar mensaje",
            deleteMessageConfirmation:"¿De verdad quieres eliminar este mensaje? Esta acción es irreversible",
            downloadFileTemplate:"Descargar el modelo de archivo",
            dropZoneFile:"O seleccione un archivo de su computadora",
            dropZoneText:"Arrastre y suelte su lista en un archivo .csv o Excel (.xls o .xlsx)",
            enablePeriodFilter: "Habilitar filtro de período",
            entryCriteria: "Criterio para entrar",
            estimatedSendAmount: "Valor de envío estimado",
            executing:"Ejecutando",
            externalBaseFile:"Archivo base externo",
            externalFileEmail:"Inserte un archivo con solo una columna con los correos electrónicos deseados",
            externalFileSms:"Ingrese un archivo con solo una columna con los DDD + números de teléfono",
            genderAndAge: "Sexo y edad",
            importExternalBase:"Importar base de clientes externos",
            importNewFile:"Importar nuevo archivo",
            inXDays: "En X dias",
            leads:"Registros",
            linkedWithFlow: "En uso",
            message:"Mensaje",
            messageHint:"Ingrese el mensaje que desea enviar a los destinatarios",
            nextStep:"Proximo paso",
            numberOfDays: "Número de días",
            numberSent:"Envíos",
            partiallySent:"Enviado parcialmente",
            pastDays: "Días passados",
            period: "Periodo",
            periodType: "Tipo de periodo",
            plainText:"Texto simple",
            plainTextHint:"WiFeed crea automáticamente una versión de texto simple para enviar si no es posible entregar la versión completa",
            recipients:"Destinatarios",
            register: "Registro",
            saveDraft:"Guardar borrador",
            saved:"Guardado",
            saving:"Guardando...",
            schedule:"Agendar envío",
            scheduleTime:"Tiempo de envío",
            scheduled:"Agendado",
            send:"Enviar",
            sendDate:"Fecha de envío",
            sendEntireDataBase:"Enviar a toda la base de registro",
            sendNow:"Enviar ahora",
            sendSegmentedList:"Enviar a la lista segmentada de registros",
            sendTest:"Enviar prueba",
            sending:"Enviando",
            sent:"Enviado",
            singleSend:"Envío único",
            template:"Modelo",
            testSubmission:"Probar envío",
            testSubmissionHint:"Los envíos de prueba sirven para verificar que la configuración se haya aplicado correctamente",
            title:"Título",
            tooltipFirstName:"Para poner el nombre de usuario que está enviando el mensaje, simplemente coloque la variable a continuación en el mensaje",
            valueNotFilled:"Este valor no se completa",
            verification:"Verificación",
            waitingToBeSent:"Esperando a ser enviado",
            warning:"Aviso",
            warningRecipientsList:"La lista de destinatarios se actualizará al momento del envío"
        }
    },
    en: {
        message:{
            access: "Access",
            actions: "Actions",
            at: "at",
            automation: "Automation",
            birthday: "Birthday",
            content: "Content",
            creditHistory: "Credit history",
            currentDataBase: "Current database",
            customSegmentedList: "Custom segmented list",
            dataOrigin: "Data origin",
            deleteMessage: "Delete Message",
            deleteMessageConfirmation: "Do you really want to delete this message? This action is irreversible",
            downloadFileTemplate: "Download file template",
            dropZoneFile: "Or select a file from your computer",
            dropZoneText: "Drag and drop your list into a .CSV or Excel file (.xls or .xlsx)",
            enablePeriodFilter: "Enable period filter",
            entryCriteria: "Entry criteria",
            estimatedSendAmount: "Estimated send amount",
            executing: "Executing",
            externalBaseFile: "External base file",
            externalFileEmail: "Insert a file with only one column with the desired emails",
            externalFileSms: "Insert a file with only one column with the area code + telephone numbers",
            genderAndAge: "Gender and age",
            importExternalBase: "Import external customer base",
            importNewFile: "Import new file",
            inXDays: "In X days",
            leads: "leads",
            linkedWithFlow: "In use",
            message: "Message",
            messageHint: "Enter the message you want to send to recipients.",
            nextStep: "Next step",
            numberOfDays: "Number of days",
            numberSent: "Sent",
            partiallySent: "Partially Sent",
            pastDays: "Past days",
            period: "Period",
            periodType: "Type of period",
            plainText: "Plain text",
            plainTextHint: "WiFeed automatically creates a plain text version to send in case the full version cannot be delivered",
            recipients: "Recipients",
            register: "Register",
            saveDraft: "Save Draft",
            saved: "Saved",
            saving: "Saving...",
            schedule: "Schedule it",
            scheduleTime: "Time",
            scheduled: "Scheduled",
            send: "Send",
            sendDate: "Send date",
            sendEntireDataBase: "Send to the entire database",
            sendNow: "Send now",
            sendSegmentedList: "Send to targeted list of leads",
            sendTest: "Send Test",
            sending: "Sending",
            sent: "Sent",
            singleSend: "Single send",
            template: "Template",
            testSubmission: "Send test",
            testSubmissionHint: "Test sends are for verifying that the settings were applied correctly",
            title: "Title",
            tooltipFirstName: "To put the name of the user you are sending the message to, just put the variable below in the message",
            valueNotFilled: "This value is not filled",
            verification: "Verification",
            waitingToBeSent: "Waiting to be sent",
            warning: "Warning",
            warningRecipientsList: "The list of recipients will be updated when the message is sent.",
            error: "Error on send"


        }
    }
}
